import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { BuildingItem } from './BuildingItem/BuildingItem';
import './ThreeDBuildingTool.css'

const city = ["臺北市", "臺中市", "基隆市", "臺南市",
    "高雄市", "新北市", "宜蘭市", "桃園市", "嘉義市",
    "新竹縣", "苗栗縣", "南投縣", "彰化縣", "新竹市",
    "雲林縣", "嘉義縣", "屏東縣", "花蓮縣", "臺東縣",
    "金門縣", "澎湖縣", "連江縣"];

const ThreeDTile = "https://3dtiles.nlsc.gov.tw/building/tiles3d/";
const I3S = "https://i3s.nlsc.gov.tw/building/i3s/SceneServer/layers/";
const roadI3S = "https://i3s.nlsc.gov.tw/road/i3s";
const road2ndI3S = "https://i3s.nlsc.gov.tw/road2nd/i3s";
const road3DTiles = "https://3dtiles.nlsc.gov.tw/road/tiles3d/";
const road2nd3DTiles = "https://3dtiles.nlsc.gov.tw/road2nd/tiles3d/";

export class ThreeDBuildingTool extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            url: "",
            isOpenHelp: false,
        }
    }

    componentDidMount() {
        let inputText = document.getElementById("buildingToolInputURL");

        inputText.addEventListener("keyup", function (event) {
            if (event.key === "Enter") {
                this.introducer();
            }
        }.bind(this));
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="套疊3D建物模型"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow} />
        );
    }

    async introducer() {
        const { buildingToolContext } = this.context;
        let param = {};
        param.url = this.state.url;
        param.urlTemplate = "{URL}"
        let outResolve;
        let waitPromise = new Promise((rs) => { outResolve = rs });
        param.callback = (success, layer) => {
            outResolve({ success, layer })
        };

        if (param.url.includes(ThreeDTile) || param.url.includes(road3DTiles) || param.url.includes(road2nd3DTiles)) {
            let urlSp = param.url.split('/');
            let index = parseInt(urlSp[urlSp.length - 2]);
            let name;
            if (param.url.includes(road3DTiles)) {
                name = "國道-原始成果版";
            }
            else if (param.url.includes(road2nd3DTiles)) {
                name = "國道-地形貼合版";
            }
            else {
                name = city[index] + "近似化建物模型3DTile";
            }

            if (!this.findItem(name)) {
                window.gMainMap.TerrainView.addOGC3DTilesLayer(param);
                let { success, layer } = await waitPromise;

                if (success) {
                    buildingToolContext.push({ name: name, layer: layer, opacity: 1.0, type: "3DTiles" });
                }
            }
            else {

            }
        }

        if (param.url.includes(I3S) || param.url.includes(roadI3S) || param.url.includes(road2ndI3S)) {
            let urlSp = param.url.split('/');
            let index = parseInt(urlSp[urlSp.length - 1]);
            let name;
            if (param.url.includes(roadI3S)) {
                name = "國道-原始成果版";
            }
            else if (param.url.includes(road2ndI3S)) {
                name = "國道-地形貼合版";
            }
            else {
                name = city[index] + "近似化建物模型I3S";
            }

            if (!this.findItem(name)) {
                window.gMainMap.TerrainView.addOGCI3SLayer(param);
                let { success, layer } = await waitPromise;

                if (success) {
                    buildingToolContext.push({ name: name, layer: layer, opacity: 1.0, type: "I3S" });
                }
            }
        }
    }

    findItem(name) {
        const { buildingToolContext } = this.context;
        let list = buildingToolContext.buildingList;
        for (let i = 0; i < list.length; i++) {
            if (list[i].name == name) {
                return true;
            }
        }

        return false;
    }

    content() {
        const { buildingToolContext } = this.context;
        return (
            <div className='threeDBuildingTool'>
                <div className='threeDBuildingBox-row'>
                    套疊網址:
                    <input type="text" id="buildingToolInputURL"
                        onChange={(e) => { this.setState({ url: e.target.value }); }}
                        style={{ width: "70%" }} />
                    <button className='threeDBuildingTool-btn' onClick={() => { this.introducer(); }}>
                        套疊
                    </button>
                </div>
                <div className='threeDBuildingBox-row'>
                    <button className='threeDBuildingTool-btn' onClick={() => { this.setState({ isOpenHelp: !this.state.isOpenHelp }) }}>{this.state.isOpenHelp ? "關閉" : "展開"}說明</button>
                    {
                        this.state.isOpenHelp ?
                            <div style={{ backgroundColor: "white" }}>
                                本工具用於顯示套疊的3DTile、I3S模型<br />
                                支援內政部國土測繪中心的介接服務<br />
                                I3S服務網址規則：https://i3s.nlsc.gov.tw/building/i3s/SceneServer/layers/建物服務代碼
                                <br />
                                3D Tiles服務網址規則：https://3dtiles.nlsc.gov.tw/building/tiles3d/建物服務代碼/tileset.json
                            </div> : null
                    }
                </div>
                <div className='threeDBuildingBox-row'>
                    套疊圖層:
                </div>
                <div className='threeDBuildingBox-row'>
                    {
                        buildingToolContext.buildingList.map((item, index) => {
                            return (
                                <BuildingItem key={item.name} name={item.name} layer={item.layer} index={index} type={item.type} />
                            );
                        })
                    }

                </div>
            </div>
        );
    }
}